export default "__VITE_ASSET__8e2d8fa0__"